<template>
  <div class="person_center_cla">
    <div class="center-card-cla">
      <div class="info_title">
        {{ $t('center.basicInfo') }}
      </div>
      <el-divider></el-divider>

      <div class="user-info-box">
        <div>
          <div class="center-info-item">
            <lable class="center-lable-cla">
              {{ $t('center.nickName') }}
            </lable>
            <div class="center-info-value-cla">
              <el-input
                v-model.trim="userInfo.nickName"
                :placeholder="this.$t('center.plaContent')"
                @change="onInputChange"
              ></el-input>
            </div>
          </div>

          <div class="center-info-item">
            <lable class="center-lable-cla">{{ $t('center.account') }}</lable>
            <div class="center-info-value-cla">{{ userInfo.loginName }}</div>

            <el-button @click="cancelAccount" style="color:red" type="text">
              {{ $t('cancelAccount.cancelAccount') }}</el-button
            >
          </div>

          <div class="center-info-item">
            <lable class="center-lable-cla">{{ $t('center.email') }}</lable>
            <div class="center-info-value-cla">
              {{
                userInfo.emailState === 0
                  ? this.$t('center.noBindEmail')
                  : userInfo.email
              }}
            </div>
            <span class="update_cla" @click="bindOrUpdateEamil()">
              {{
                userInfo.emailState === 0
                  ? this.$t('center.bindEmail')
                  : this.$t('center.updateEamil')
              }}
            </span>
          </div>

          <div class="center-info-item">
            <lable class="center-lable-cla">{{ $t('center.phone') }}</lable>
            <div class="center-info-value-cla">
              {{
                userInfo.phoneState === 0
                  ? this.$t('center.noBindPhone')
                  : userInfo.prefix + userInfo.phone
              }}
            </div>
            <span class="update_cla" @click="bindOrUpdatePhone()">
              {{
                userInfo.phoneState === 0
                  ? this.$t('center.bindPhone')
                  : this.$t('center.updatePhone')
              }}
            </span>
          </div>

          <div class="center-info-item">
            <lable class="center-lable-cla">{{ $t('center.password') }}</lable>
            <div class="center-info-value-cla">
              {{ userInfo.password }}
            </div>
            <span class="update_cla" @click="updatePassword()">{{
              $t('center.updatePassword')
            }}</span>
          </div>
        </div>
        <div>
          <el-upload
            class="avatar-uploader"
            action="/apiv1/account/uploadHeadImg"
            :data="imgData"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <img
              v-if="userInfo.headImg"
              :src="userInfo.headImg"
              class="avatar"
            />
            <div class="edit-header-img-cla">
              <i class="el-icon-edit"></i>
            </div>
          </el-upload>
        </div>
      </div>

      <el-divider class="line-cla"></el-divider>
      <div class="socialAccount-cla info_title">
        {{ $t('center.socialAccount') }}
      </div>
      <div class="center-info-item">
        <lable class="center-lable-cla">{{ $t('center.wetchat') }}</lable>
        <div class="center-info-value-cla">
          <img
            style="width: 32px; height: 32px; vertical-align: middle"
            v-if="userInfo.weChatState === 0"
            src="@/assets/login/wetchat_1.png"
          />
          <img
            style="width: 32px; height: 32px; vertical-align: middle"
            v-else
            src="@/assets/login/wetchat_2.png"
          />
          <el-popover placement="right" trigger="manual" v-model="showQrCode">
            <div v-if="!showOrHidden" class="wx-log-box-cla">
              <div style="text-align:right">
                <i
                  class="el-icon-close"
                  style="font-size:14px;cursor: pointer;"
                  @click="closeQr"
                ></i>
              </div>
              <div class="border-item-cla1"></div>
              <div class="border-item-cla2"></div>
              <div class="border-item-cla3"></div>
              <div class="border-item-cla4"></div>
              <div
                id="id_qrCode"
                style="width:33.33rem;height: 26.33rem;display:flex;justify-content:center"
              ></div>
              <!-- <iframe
                id="wechart-login-iframe"
                scrolling="no"
                style="width:33.33rem;height:33.33rem;"
                frameborder="0"
                allowtransparency="true"
                :src="setSrc"
                sandbox="allow-scripts allow-top-navigation allow-same-origin"
              ></iframe> -->
            </div>
            <span
              style="color: #ccc"
              v-if="userInfo.weChatState === 0"
              slot="reference"
              >{{ $t('center.nobindWetchat') }}
              <span @click="bindWx()" class="update_cla">
                {{ $t('center.bindWetchat') }}</span
              >
            </span>

            <span
              v-else
              @click="unbindWx()"
              class="update_cla"
              slot="reference"
              >{{ $t('center.updateWetchat') }}</span
            >
          </el-popover>
        </div>
      </div>

      <el-divider class="line-cla"></el-divider>

      <div class="socialAccount-cla info_title">
        {{ $t('cancelAccount.agreements') }}
      </div>
      <div>
        <span> {{ $t('cancelAccount.developer') }}</span>
        <el-button
          style="margin-left:20px"
          @click="showAgreementDia('developer')"
          type="text"
          >{{ $t('cancelAccount.view') }}</el-button
        >
      </div>
      <div>
        <span>{{ $t('cancelAccount.privacyPolicy') }} </span
        ><el-button
          style="margin-left:20px"
          @click="showAgreementDia('privacyPolicy')"
          type="text"
          >{{ $t('cancelAccount.view') }}</el-button
        >
      </div>
      <div>
        <span>{{ $t('cancelAccount.dataProcess') }} </span
        ><el-button
          style="margin-left:20px"
          @click="showAgreementDia('dataProcess')"
          type="text"
          >{{ $t('cancelAccount.view') }}</el-button
        >
      </div>
    </div>
    <zk-modify-pwd
      :appendBody="false"
      @close="dialogVisible = false"
      :dialogVisible="dialogVisible"
      :redirectLogin="true"
    ></zk-modify-pwd>
    <!-- 邮箱对话框 -->
    <emailDialog
      v-bind="emailProp"
      @closeEmail="closeEmail"
      @submitEmail="submitEmail"
      ref="emailDialog"
    ></emailDialog>
    <phoneDialog
      v-bind="phoneProp"
      @closePhone="closePhone"
      @submitPhone="submitPhone"
      ref="phoneDialog"
    ></phoneDialog>

    <cancleAccount :userInfo="results" ref="cancleAccount"></cancleAccount>

    <!-- <el-dialog
      :title="$t('common.warningNotice')"
      :visible.sync="disposeAccount"
      width="40%"
      :showClose="false"
    >
      <template v-if="isAgree">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-row :gutter="20">
            <el-col :span="16">
              <template v-if="isEmail">
                <el-form-item :label="$t('center.email')" prop="email">
                  <el-input v-model="form.email" :disabled="true"></el-input>
                </el-form-item>
              </template>
              <template v-else>
                <el-form-item :label="$t('center.phone')">
                  <el-input v-model="form.phone" :disabled="true"></el-input>
                </el-form-item>
              </template>
            </el-col>
            <el-col :span="6">
              <el-button
                type="primary"
                @click="changeWay(isEmail)"
                :disabled="!isChange"
                >{{ $t('developer.changeWay') }}</el-button
              >
            </el-col>
            <el-col :span="16">
              <el-form-item :label="$t('center.code')" prop="code">
                <el-input v-model="form.code"> </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <timing
                :status="true"
                @toGetCode="toGetCode"
                ref="timing"
              ></timing>
            </el-col>
          </el-row>
        </el-form>
      </template>
      <template v-else>
        <div class="dispose-account-cla">
          <div class="dispose-icon-cla"><i class="el-icon-warning"></i></div>
          <div calss="">
            {{ $t('center.disposeAccountTips') }}
          </div>
        </div>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDisposeAccount">{{
          $t('common.cancel')
        }}</el-button>
        <el-button type="primary" @click="handleDisposeAccount">{{
          isAgree ? $t('common.confirm') : $t('center.isGoOn')
        }}</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
import * as centerApi from '@/services/userCenter.js'
import defaultHead from '@/assets/login/default_head.png'
import wxlogin from 'vue-wxlogin'
import { mapActions } from 'vuex'
import { Base64 } from 'js-base64'
import { getFontSize } from '@/utils/rem.js'
import emailDialog from './dialog/emailDialog'
import phoneDialog from './dialog/phoneDialog'
import cancleAccount from './dialog/cancelAccount.vue'
import timing from '@/components/timing'
import { getLanguage } from '@/utils/utils.js'
export default {
  data() {
    let checkCode = (rules, value, callback) => {
      if (value) {
        return callback()
      }
    }
    return {
      form: {
        code: '',
        email: '',
        phone: ''
      },
      rules: {
        code: this.validatorInputEmptyRule(true, 6, checkCode)
      },
      dialogVisible: false,
      userInfo: {
        headImg: defaultHead,
        nickName: '',
        email: '',
        phone: '',
        loginName: '',
        password: '******',
        weChatState: 0,
        emailState: 0,
        phoneState: 0,
        prefix: ''
      },
      res: [],
      emailProp: {
        title: '',
        show: false,
        status: 0,
        userInfo: {},
        isUpdate: false
      },
      phoneProp: {
        title: '',
        show: false,
        status: 0,
        userInfo: {},
        isUpdate: false
      },
      imgData: {
        userId: '',
        lang: ''
      },
      results: {},
      showQrCode: false,
      timer: null,
      scanId: '',
      lang: '',
      showOrHidden: false,
      FontSize: '12px',
      disposeAccount: true,
      isAgree: true,
      isEmail: false,
      isChange: false,
      getFontSize: () => {
        this.FontSize = getFontSize()
      }
    }
  },
  watch: {
    'userInfo.email': {
      handler(val) {
        this.userInfo.email = this.emailFormat(val)
      }
    },
    'userInfo.phone': {
      handler(val) {
        this.userInfo.phone = this.phoneFormat(val)
      }
    }
  },
  inject: ['reload'],
  created() {
    this.getBasiceUserInfo()
  },
  components: {
    wxlogin,
    emailDialog,
    phoneDialog,
    cancleAccount,
    timing
  },
  mounted() {
    this.getFontSize()
    window.addEventListener('resize', this.getFontSize, true)
    this.getWxQrCode()
  },
  computed: {
    href() {
      return 'data:text/css;base64,' + Base64.encode(this.css)
    },
    css() {
      return `
        html{
          font-size:${this.FontSize};
        }
        .impowerBox .title {display: none;}
        .impowerBox .info {width: 260px;}
        .status_icon {display: none}
        .impowerBox {
            display:block;
        }
        .impowerBox .status {text-align: center;}
        .impowerBox .status.status_browser, .redesign-msg{display:none}
        .impowerBox .qrcode{
            width: 20rem;
            margin-top:0;
            position: absolute;
            left: 50%;
            top:4rem;
            margin-left: -10rem;
            border: 1px solid rgba(0,0,0,0.10);
        }
      `
    },
    setSrc() {
      console.log(this.$root.wxAppid, '  ---', this.$root.wxCallbackAddress)
      var _url =
        'https://open.weixin.qq.com/connect/qrconnect?appid=' +
        this.$root.wxAppid +
        '&scope=' +
        'snsapi_login' +
        '&redirect_uri=' +
        this.$root.wxCallbackAddress +
        '&state=' +
        'bind' +
        '&login_type=jssdk&style=' +
        'black' +
        '&href=' +
        this.href
      return _url
    }
  },
  methods: {
    ...mapActions(['setAvater']),
    showAgreementDia(type) {
      this.$refs.cancleAccount.showAgreementDia(type)
    },
    cancelAccount() {
      this.$refs.cancleAccount.showCancelAccountTip()
    },
    changeWay(val) {
      this.isEmail = !val
      this.$refs.timing.clearTimer()
    },
    // hasPhoneAndEmail() {
    //   let hasPhone = this.userInfo.phoneState && this.userInfo.phone
    //   let hasEmail = this.userInfo.emailState && this.userInfo.email
    //   if (!hasPhone && !hasEmail) {
    //     this.$message.warning(this.$t('warningOperation.hasPhoneOrEmail'))
    //     return false
    //   }
    //   if (hasPhone && hasEmail) {
    //     this.isEmail = false
    //     this.isChange = true
    //   } else if (hasPhone && !hasEmail) {
    //     this.isEmail = false
    //     this.isChange = false
    //   } else if (!hasPhone && hasEmail) {
    //     this.isEmail = true
    //     this.isChange = false
    //   }
    //   return true
    // },
    // toGetCode() {
    //   let params = {
    //     type: 'accountCancellation'
    //   }
    //   if (this.isEmail) {
    //     params.email = this.res.email
    //     centerApi
    //       .getEmailCode(params)
    //       .then(data => {
    //         if (data.code === '00000000') {
    //           this.$refs.timing.beginTime()
    //         } else {
    //           this.errorMessage(data.message)
    //         }
    //       })
    //       .catch(e => console.log(e))
    //   } else {
    //     params.phone = this.res.phone
    //     params.prefix = this.res.prefix
    //     centerApi
    //       .sendPhoneCode(params)
    //       .then(data => {
    //         if (data.code === '00000000') {
    //           this.$refs.timing.beginTime()
    //         } else {
    //           this.errorMessage(data.message)
    //         }
    //       })
    //       .catch(e => {})
    //   }
    // },
    // closeDisposeAccount() {
    //   this.disposeAccount = false
    //   this.isAgree = false
    //   this.form.code = ''
    // },
    // handleDisposeAccount() {
    //   if (!this.isAgree) {
    //     this.isAgree = true
    //     // 判断

    //     this.form.email = this.userInfo.email

    //     this.form.phone = this.userInfo.prefix + this.userInfo.phone

    //     return true
    //   }
    //   this.$refs.ruleForm.validate(valid => {
    //     if (valid) {
    //       let params = {
    //         type: 'accountCancellation',
    //         code: this.form.code
    //       }
    //       if (this.isEmail) {
    //         params.loginName = this.res.email
    //       } else {
    //         params.loginName = this.res.phone
    //         params.prefix = this.res.prefix
    //       }
    //       centerApi
    //         .accountCancellation(params)
    //         .then(data => {
    //           if (data.code === '00000000') {
    //             this.$message.success(
    //               this.$t('successOperation.cancellationSuccess')
    //             )
    //             setTimeout(() => {
    //               this.$router.push('/')
    //             }, 1500)
    //           } else {
    //             this.errorMessage(data.message)
    //           }
    //         })
    //         .catch(e => console.log(e))
    //     } else {
    //       console.log('error sumbit')
    //     }
    //   })
    // },
    // accountCancellation() {
    //   // if (!this.userInfo.email) {
    //   //   this.$message.warning(this.$t('center.isNotBind'))
    //   //   return
    //   // }
    //   if (this.hasPhoneAndEmail()) {
    //     this.disposeAccount = true
    //   }
    // },

    showPrivacy() {},
    submitEmail(emailForm) {
      // 判断绑定还是更新
      if (this.emailProp.status === 0) {
        if (!this.emailProp.isUpdate) {
          // 绑定
          let params = {
            content: emailForm.email,
            type: 'bindEmail',
            ...emailForm
          }
          centerApi
            .bindEmail(params)
            .then(data => {
              if (data.code === '00000000') {
                this.$message.success(this.$t('operationMsg.bindSuc'))
                this.getBasiceUserInfo()
                this.closeEmail()
              } else {
                this.errorMessage(data.message)
              }
            })
            .catch(e => console.log('submitEmail():', e))
        } else {
          // 更新
          let params = {
            loginName: sessionStorage.getItem('loginName'),
            deviceType: '1',
            type: 'bindEmail',
            content: emailForm.email,
            ...emailForm
          }
          centerApi
            .updateEmailAndPhone(params)
            .then(data => {
              if (data.code === '00000000') {
                this.$message.success(this.$t('operationMsg.updateSuc'))
                this.getBasiceUserInfo()
                this.closeEmail()
              } else {
                this.$message.error(data.message)
              }
            })
            .catch(e => console.log('submitEmail():', e))
        }
      } else {
        // 先验证后更新
        let params = {
          content: emailForm.email,
          email: emailForm.email,
          type: 'checkEmail',
          code: emailForm.code,
          deviceType: '1'
        }
        this.emailProp.isUpdate = true // 关闭时 置false
        centerApi
          .comCheckCode(params)
          .then(data => {
            if (data.code === '00000000') {
              // 验证成功
              this.emailProp.title = this.$t('center.updateEamil')
              this.emailProp.status = 0
              //  清空子组件
              this.$refs.emailDialog.init()
            } else {
              this.errorMessage(data.message)
            }
          })
          .catch(e => console.log('getVerEmailCode()', e))
      }
    },
    submitPhone(phoneForm) {
      // 判断绑定还是更新
      if (this.phoneProp.status === 0) {
        if (!this.phoneProp.isUpdate) {
          // 绑定
          let params = {
            content: phoneForm.phone,
            type: 'bindPhone',
            ...phoneForm
          }
          centerApi
            .bindPhone(params)
            .then(data => {
              if (data.code === '00000000') {
                this.$message.success(this.$t('wxbind.bindPhoneSuc'))
                this.getBasiceUserInfo()
                this.closePhone()
              } else {
                this.errorMessage(data.message)
              }
            })
            .catch(e => console.log('submitPhone():', e))
        } else {
          // 更新
          let params = {
            loginName: sessionStorage.getItem('loginName'),
            deviceType: '2',
            type: 'bindPhone',
            content: phoneForm.phone,
            ...phoneForm
          }
          centerApi
            .updateEmailAndPhone(params)
            .then(data => {
              if (data.code === '00000000') {
                this.$message.success(this.$t('operationMsg.updateSuc'))
                this.getBasiceUserInfo()
                this.closePhone()
              } else {
                this.$message.error(data.message)
              }
            })
            .catch(e => console.log('submitPhone():', e))
        }
      } else {
        // 先验证后更新
        let params = {
          content: phoneForm.phone,
          phone: phoneForm.phone,
          prefix: phoneForm.prefix,
          type: 'checkPhone',
          code: phoneForm.code,
          deviceType: '2'
        }
        this.phoneProp.isUpdate = true // 关闭时 置false
        centerApi
          .comCheckCode(params)
          .then(data => {
            if (data.code === '00000000') {
              // 验证成功
              this.phoneProp.title = this.$t('center.updatePhone')
              this.phoneProp.status = 0
              //  清空子组件
              this.$refs.phoneDialog.init()
            } else {
              this.errorMessage(data.message)
            }
          })
          .catch(e => console.log('getVerPhoneCode()', e))
      }
    },
    isBindEmail() {
      this.emailProp.title =
        this.userInfo.emailState === 0
          ? this.$t('center.bindEmail')
          : this.$t('center.auth')
      this.emailProp.status = this.userInfo.emailState // 0 绑定  1更新
    },
    isBindPhone() {
      this.phoneProp.title =
        this.userInfo.phoneState === 0
          ? this.$t('center.bindPhone')
          : this.$t('center.auth')
      this.phoneProp.status = this.userInfo.phoneState // 0 绑定  1修改
    },
    closeEmail() {
      // 根据当前用户状态 还原
      this.$refs.emailDialog.init()
      this.emailProp.show = false
      this.emailProp.isUpdate = false
      this.isBindEmail()
    },
    closePhone() {
      // 根据当前用户状态 还原
      this.$refs.phoneDialog.init()
      this.phoneProp.show = false
      this.phoneProp.isUpdate = false
      this.isBindPhone()
    },
    bindOrUpdateEamil() {
      this.emailProp.show = true
      this.isBindEmail()
      this.$refs.emailDialog.isFormatEmail()
    },
    bindOrUpdatePhone() {
      this.phoneProp.show = true
      this.isBindPhone()
      this.$refs.phoneDialog.isFormatPhone()
    },
    closeQr() {
      this.showQrCode = false
      clearInterval(this.timer)
      this.timer = null
    },
    getWxQrCode() {
      this.scanId = new Date().getTime() + Math.floor(Math.random() * 10 + 1)
      this.lang = getLanguage()
      if (this.lang === 'zh-cn') {
        this.lang = 'zh_CN'
      }
      /* eslint-disable */
      new WxLogin({
        self_redirect: false,
        id: 'id_qrCode',
        appid: this.$root.wxAppid,
        scope: 'snsapi_login',
        // https://alpha.dbs.zkclouds.com/
        redirect_uri: `${this.$root.wxCallbackAddress}apiv1/wx/wxBindCallBack?scanId=${this.scanId}&lang=${this.lang}&language=${this.lang}`,
        state: 'bind',
        style: 'black',
        href: this.href
      })
    },
    bindWx() {
      if (this.userInfo.weChatState === 0) {
        this.getWxQrCode() // 解绑之后 二维码出不来
      }

      this.showQrCode = !this.showQrCode // 暂时二维码

      if (this.showQrCode) {
        let params = {
          scanId: this.scanId
        }
        this.timer = setInterval(() => {
          centerApi.checkScan(params).then(data => {
            // 定时请求 '是否扫码'
            if (data && data !== '') {
              if (data.code === '00000000') {
                this.$message.success(this.$t('operationMsg.bindSuc'))
                this.showQrCode = false
                clearInterval(this.timer)
                this.timer = null
                this.reload()
              } else if (data.code === '11111111') {
                // 不处理  绑定没结果
              } else {
                this.$message.error(data.message)
                this.showQrCode = false
                clearInterval(this.timer)
                this.timer = null
              }
            }
          })
        }, 1000)
      } else {
        // 不显示二维码  清除定时器
        clearInterval(this.timer)
        this.timer = null
      }
    },
    unbindWx() {
      this.$confirm(
        this.$t('wxbind.unbindWxTips'),
        this.$t('wxbind.unbindWx'),
        {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          // 解绑
          let res = JSON.parse(sessionStorage.getItem('loginInfo'))
          let params = {
            userId: res.id
          }
          centerApi
            .unboundWeChat(params)
            .then(data => {
              if (data.code === '00000000') {
                this.$message.success(data.message)
                this.reload()
              } else {
                this.$message.error(data.message)
              }
            })
            .catch(e => {})
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('common.cancelDelete')
          })
        })
    },

    beforeAvatarUpload(file) {
      let loginInfo = JSON.parse(sessionStorage.getItem('loginInfo'))
      this.imgData.userId = loginInfo.id
      const isJPG = ['image/jpeg', 'image/png'].includes(file.type)
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG) {
        this.$message.error(this.$t('common.uploadCompanyLogo'))
        return false
      }
      if (!isLt2M) {
        this.$message.error(this.$t('common.uploadCompanyLogoSize'))
        return false
      }
      return isJPG && isLt2M
    },
    handleAvatarSuccess(res, fileInfo) {
      if (res.code === '00000000') {
        this.$message.success(this.$t('operationMsg.uploadSuc'))
        this.userInfo.headImg = res.payload.results.url
        this.setAvater(Math.random())
        let result = sessionStorage.getItem('loginInfo')
        let r = Object.assign({}, JSON.parse(result))
        r.headImg = res.payload.results.url
        sessionStorage.setItem('loginInfo', JSON.stringify(r))
      } else {
        this.$message.error(res.message)
      }
    },

    onInputChange(value) {
      // 更新用户名
      let params = {
        loginName: sessionStorage.getItem('loginName'),
        nickName: this.userInfo.nickName
      }
      centerApi
        .updateNickName(params)
        .then(data => {
          if (data.code === '00000000') {
            this.$message.success(this.$t('center.updateNicknameSuc'))
          } else {
            this.$message.error(data.message)
          }
        })
        .catch(e => {})
    },

    updatePassword() {
      // 更新密码
      this.dialogVisible = true
    },

    getBasiceUserInfo() {
      // 获取用户基本信息
      let params = {
        loginName: sessionStorage.getItem('loginName')
      }
      centerApi
        .getPersonCenterDetail(params)
        .then(data => {
          if (data.code === '00000000') {
            let results = data.payload.results.zeusUserVO
            this.res = Object.assign({}, results)
            this.emailProp.userInfo = this.phoneProp.userInfo = results
            this.results = results
            if (results.headImg) {
              this.userInfo.headImg = results.headImg
            }
            this.userInfo.nickName = results.nickName
            this.userInfo.loginName = results.loginName
            this.userInfo.email = results.email
            this.userInfo.phone = results.phone
            this.userInfo.weChatState = +results.weChatState
            this.userInfo.emailState = +results.emailState
            this.userInfo.phoneState = +results.phoneState
            this.userInfo.prefix = results.prefix
            if (this.userInfo.emailState === 0) {
              this.userInfo.email = ''
            }
            if (this.userInfo.phoneState === 0) {
              this.userInfo.phone = ''
            }
          } else {
            this.$message.error(data.message)
          }
        })
        .catch(e => {})
    }
  }
}
</script>
<style lang="less" scoped>
@import '~@/styles/var.less';
.dispose-account-cla {
  display: flex;
  justify-content: space-around;
  .dispose-icon-cla {
    width: 20%;
    font-size: 24px;
    color: @ststusFailed;
    text-align: center;
  }
}
.person_center_cla {
  padding: 24px;
  .el-divider--horizontal {
    margin: 0px;
  }
  .update_cla {
    color: #78bc27;
    cursor: pointer;
  }
  .center-card-cla {
    background: #ffffff;
    box-shadow: 0 2px 8px 0 rgba(0, 55, 103, 0.04);
    border-radius: 4px;
    border-radius: 4px;
    padding: 20px 40px;
    .user-info-box {
      margin-top: 24px;
      display: flex;
      justify-content: space-between;
    }
    .center-info-item {
      display: flex;
      align-items: center;
      .center-lable-cla {
        height: 41px;
        line-height: 41px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.9);
        letter-spacing: 0;
        width: 100px;
      }
      .center-info-value-cla {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.65);
        letter-spacing: 0;
        line-height: 21px;
        width: 250px;
      }

      .update_cla {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #4db22f;
        letter-spacing: 0;
        line-height: 21px;
      }
    }
    .socialAccount-cla {
      margin-top: 12px;
    }
    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader {
      border-color: @themeColor;
      position: relative;
      &:hover {
        .edit-header-img-cla {
          position: absolute;
          left: 0;
          bottom: 0;
          display: inline-block;
          width: 100%;
          background: #666666;
          .el-icon-edit {
            color: #ffffff;
          }
        }
      }
      .edit-header-img-cla {
        display: none;
      }
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 100px;
      height: 126px;
      line-height: 126px;
      text-align: center;
    }
    .avatar {
      width: 100px;
      height: 126px;
      display: block;
      // border-radius: 50%;
      border-radius: 2px;
    }

    .info_title {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.9);
      letter-spacing: 0;
      margin-bottom: 12px;
    }
  }
  .line-cla {
    margin-top: 10px;
  }
}
.wx-log-box-cla {
  position: relative;
}
.border-item-cla {
  width: 18px;
  height: 18px;
  z-index: 1;
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.7);
  position: absolute;
  border-radius: 2px;
}
.border-item-cla1 {
  .border-item-cla;
  top: 67px;
  left: 80px;
  border-width: 2px 0 0 2px;
}
.border-item-cla2 {
  .border-item-cla;
  top: 67px;
  left: 302px;
  border-width: 2px 2px 0 0;
}
.border-item-cla3 {
  .border-item-cla;
  top: 292px;
  left: 80px;
  border-width: 0 0 2px 2px;
}
.border-item-cla4 {
  .border-item-cla;
  top: 292px;
  left: 302px;
  border-width: 0 2px 2px 0;
}
/deep/ .smartdbs-privacy-cla {
  max-height: 600px;
  overflow: auto;
  /deep/ .el-dialog__body {
    height: 480px;
    .privacy-content {
      width: 96%;
    }
  }
  /deep/ .el-dialog__footer {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/personCenter/center.vue